import { GovField } from "@publicMirage/components/govReact/GovField";
import { Button, ErrorText, Fieldset, FormGroup, LabelText } from "govuk-react";
import React, { memo, useEffect } from "react";
import { useForm } from "../hooks/formContext";
import { PrePpWlDescriptionOfDevelopmentDevelopmentTypes } from "@shared/prePublicPortalWestLindsay/contracts/IPrePpWlForm";
import { PrePpWlFormComponentStepProps } from "../PrePublicPortalWlForm";
import Box from "@mui/material/Box";

export const PrePpWlDescriptionOfDevelopmentStep = memo((props: PrePpWlFormComponentStepProps) => {
    const { next } = props;
    const { toFieldProps, getFieldProp, setFieldValue, previous } = useForm();
    const errorMsg = getFieldProp("typeOfDevelopment", "errorMsg");
    const typeOfDevelopmentValue = getFieldProp("typeOfDevelopment", "value");

    useEffect(() => {
        setFieldValue("developmentScale", "");
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [typeOfDevelopmentValue]);

    return (
        <>
            <Fieldset>
                <Fieldset.Legend size="LARGE">Description of the Proposed Development</Fieldset.Legend>
            </Fieldset>
            <FormGroup error={!!errorMsg}>
                <LabelText className="required">Select the type of development</LabelText>
                <ErrorText>{errorMsg}</ErrorText>
                <GovField
                    {...toFieldProps("typeOfDevelopment", "RADIO", PrePpWlDescriptionOfDevelopmentDevelopmentTypes.ALTERATIONS_EXTENSIONS)}
                    label="Make alterations or extensions to an existing house"
                />
                <GovField {...toFieldProps("typeOfDevelopment", "RADIO", PrePpWlDescriptionOfDevelopmentDevelopmentTypes.NEW_DWELLINGS)} label="Build new dwellings" />
                <GovField
                    {...toFieldProps("typeOfDevelopment", "RADIO", PrePpWlDescriptionOfDevelopmentDevelopmentTypes.RETAIL_OFFICE_INDUSTRIAL)}
                    label="Retail/office/industrial development"
                />
                <GovField
                    {...toFieldProps("typeOfDevelopment", "RADIO", PrePpWlDescriptionOfDevelopmentDevelopmentTypes.OTHER)}
                    label="Any other type of development (e.g. solar panels)"
                />
            </FormGroup>
            <Box display="flex" justifyContent="space-between">
                <Button onClick={previous}>Previous</Button>
                <Button onClick={next}>Next</Button>
            </Box>
        </>
    );
});
